if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.buttonBuyNow = this.querySelector('.shopify-button-buy-now');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.buttonBuyNow.addEventListener('click', this.buyNow.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.submitButton.style.setProperty('--error-message-height', `${this.errorMessage.offsetHeight + parseFloat(getComputedStyle(this.querySelector('.product-form__error-message-wrapper')).marginBottom)}px`);
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      async buyNow(evt) {
        evt.preventDefault();
        if (this.buttonBuyNow.getAttribute('aria-disabled') === 'true') return;
        let configCheckout = null;
        let customerId = null;

        if (!configCheckout) {
          const mode = window.API_CONFIG.mode;
          configCheckout = window.API_CONFIG[mode];
        }

        if (window.customerId) {
          customerId = window.customerId;
        } else {
          document.querySelector('#account-dropdown [href="/account/login"]').click();
          return;
        }
        if (!customerId && window.Shopify && window.Shopify.customer) customerId = window.Shopify.customer.id;
        if (!customerId && window.customer && window.customer.id) customerId = window.customer.id;

        this.handleErrorMessage();

        this.buttonBuyNow.setAttribute('aria-disabled', true);
        this.buttonBuyNow.classList.add('loading');
        this.buttonBuyNow.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.buttonBuyNow.classList.remove('loading');
            if (!this.error) this.buttonBuyNow.removeAttribute('aria-disabled');
            this.buttonBuyNow.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });

        const cartResponse = await fetch("/cart.js");
        if (!cartResponse.ok) {
          console.log("Không thể tải thông tin giỏ hàng.");
          return;
        }
        const cartData = await cartResponse.json();
        const discountTitle = this.getDiscountTitle(cartData);

        const response = await fetch(`${configCheckout.url}/api/start-checkout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-TheviaTea-Key": configCheckout.key,
          },
          body: JSON.stringify({
            cart_token: cartData.token,
            customer_id: customerId,
            automatic_discount_code: discountTitle,
          }),
        });

        if (response.ok) {
          const result = await response.json();

          if (result.success) {
            window.location.href = result?.data?.redirectUrl;
          } else {
            console.log(result.message || "Không thể bắt đầu thanh toán.");
          }
        } else {
          console.log("❌ API Error:", response.status, response.statusText);
          console.error("Lỗi kết nối server.");
        }
      }

      getDiscountTitle(cart) {
        // discount_codes (only if applicable)
        if (cart.discount_codes && cart.discount_codes.length > 0) {
          const code = cart.discount_codes.find(c => c.applicable);
          if (code) return code.code;
        }

        // cart-level discounts
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          const discount = cart.cart_level_discount_applications[0];
          if (discount && discount.title) return discount.title;
        }

        // line-level discounts (items)
        if (cart.items && cart.items.length > 0) {
          for (const item of cart.items) {
            if (item.discounts && item.discounts.length > 0) {
              return item.discounts[0].title;
            }
          }
        }

        return '';
      }
    }
  );
}
